/**
 * This module handles widget HTML templates.
 */
(function() {

  "use strict";

  define('fg-arv/templates',[],function() {
    return {

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Creates the HTML template for a specific fg-arv widget.
       * @param {string} mapElementID The ID of the element for the map.
       * @returns The HTML template for a specficic fg-arv widget.
       */
      createWidgetTemplate: function(mapElementID) {
        return "<div class='fg-arv-widget'><div id='" + mapElementID + "' class='map'></div>" + this.createFormTemplate() + "</div>";
      },
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Creates the HTML template for the widget form.
       * @returns The HTML template for the widget form.
       */
      createFormTemplate: function() {
        return '' +
          "<div class='form-container'>" +
          "<form>" +
          "<div class='form col-xs-12 col-sm-12 col-sm-12'>" +
          "<div class='form-components-container '>" +

          "<div class='label hidden-xs col-sm-12 row margin-left label-from-to-component'><div class='col-xs-6'>From</div><div class='col-xs-6 label-to'>To</div></div>" +
          "<div class='col-xs-12 col-sm-12 row'>" +
          "<div class='col-mb-12 col-xs-6 form-component from-component'></div>" +
          "<div class='col-mb-12 col-xs-6  form-component to-component'></div>" +
          "<div class='form-component fg-arv_transfer' title='Exchange from / to values.'><span class='form-control transfer-icon'></span></div>" +
          "</div>" +

          //          "<div class='label hidden-xs col-sm-12 row margin-left label-options-component'><div class='col-xs-7'>Departure information</div><div class='col-xs-5'>Route options</div></div>" +
          "<div class='col-xs-12 col-sm-12 row'>" +
          "<div class='col-mb-12 col-xs-5 departure-date-component'>" +
          "<div class='col-mb-6 col-xs-6  form-component complete-form-only fg-arv_date-component'></div>" +
          "<div class='xxs-screen col-mb-6  col-xs-6  form-component complete-form-only journey-mode-component' title='Journey mode selector.'><div class='form-control form-input'></div></div>" +
          "</div>" +
          "<div class='xxs-screen col-mb-6 col-xs-2  form-component complete-form-only fg-arv_time-component' title='Time selector.'></div>" +
          "<div class='col-mb-6 col-xs-3 col-sm-3 route-options-component row'>" +
          "<div class='col-xs-12 col-sm-12 form-component complete-form-only fg-arv_criteria-component' title='Criteria.'><div class='form-control form-input'></div></div></div>" +
          "<div class='col-mb-12 col-xs-2 col-sm-2 form-component fg-arv_go-component'>" +
          "<div class='form-input'><button type='button' class='form-control btn btn-primary go' title='Go with these options.'>" +
          "Find routes" +
          "</button></div>" +
          "</div>" +

          //"<div class='col-mb-3 col-xs-2 col-md-1 col-lg-2 form-component help-component'><div class='form-input'></div></div>" +
          "</div>" +
          "</div>" +
          "</div>" +
          "</form>" +
          "<div class='fg-arv_info-journey-component'>" +
          "</div>" +
          "</div>";
      },

      createNoRoutesDiv: function() {
        return "<div class='no-routes'><span>There are no routes for this data</span></div>";
      },

      createNoRoutesDivMobile: function() {
        return "<div class='no-routes'>" +
          "<div class='panel-directions'>" +
          "<div class='pointer' title='New search'></div>" +
          "</div>" +
          "<div class='error-message'><span>There are no routes for this data</span></div></div>";
      }
    };
  });

})();

